import { Component, OnInit, AfterViewInit, Renderer2, ElementRef, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { CommonModule } from '@angular/common';
import { FooterComponent } from "../footer/footer.component";
import { TranslationSyncService } from '../../services/translation-sync.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FaceReadyService } from '../../services/face-ready.service';

@Component({
  selector: 'app-home',
  imports: [CommonModule, FooterComponent, TranslateModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild('containerHome', { static: false }) containerRef!: ElementRef<HTMLElement>;
  @Output() toggleImprint = new EventEmitter<void>();
  @Output() togglePrivacy = new EventEmitter<void>();
  @Input() imprintBusy = false;
  private darkContainer!: HTMLElement;
  isDarkMode = false;
  delayedImageSrc: string = 'home/hero_dark.webp';
  activeIndex = 0;
  @Input() activeFace: number = 0;
  isHidden = false;
  currentLang: string;
  @ViewChild('homeImg', { static: true }) homeImgRef!: ElementRef<HTMLDivElement>;

  constructor(
    private renderer: Renderer2,
    private themeService: ThemeService,
    private translate: TranslateService,
    private sync: TranslationSyncService,
  private faceReady : FaceReadyService) {
    this.currentLang = this.translate.currentLang || 'de';
  }

  ngOnInit(): void {
    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      Promise.resolve().then(() => {
        const triggeredByToggle = this.themeService.wasThemeToggled();
        this.updateTheme(triggeredByToggle);
      });
    });

    if (window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
  document.querySelectorAll('.tooltip').forEach(tip => {
    const parent = tip.parentElement;

    // Tooltip anzeigen, wenn Eltern-Element getappt wird
    parent.addEventListener('click', () => {
      tip.classList.add('show');
      setTimeout(() => tip.classList.remove('show'), 2000); // 2 Sekunden sichtbar
    });
  });
}
  }

  ngAfterViewInit(): void {
    this.darkContainer = document.getElementById('dark-container-home') as HTMLElement;

    // für data-transfe bei spracheinstellung
    this.registerAll(this.containerRef.nativeElement);
    this.registerAll(this.darkContainer);

    // // 🔥 2️⃣ Dark-Container initial ausblenden
    this.renderer.removeClass(this.darkContainer, 'active');

    // 🔥 5️⃣ Theme sofort beim Laden aktualisieren
    Promise.resolve().then(() => {
      const triggeredByToggle = this.themeService.wasThemeToggled();
      this.updateTheme(triggeredByToggle);

    });
  }

  private registerAll(root: HTMLElement) {
    root
      .querySelectorAll<HTMLElement>('[data-translate]')
      .forEach(el => {
        const key = el.getAttribute('data-translate')!;
        this.sync.register(el, key);
      });
  }

  private updateTheme(triggeredByToggle: boolean): void {
    if (!this.darkContainer || !this.containerRef?.nativeElement) {
      return;
    }

    // Update Image
    this.themeService.updateDarkHomeImage(triggeredByToggle, this.darkContainer);

    // Update Theme
    this.themeService.toggleThemeMode(this.isDarkMode, this.renderer, this.containerRef.nativeElement, this.darkContainer);

    this.faceReady.markReady('home');

  }
}
